// src/pages/Contact.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../common/Navbar';
import Footer from '../common/Footer';
import contactBg from '../assets/contact-bg3.png';
import phone from '../assets/phone3.png';
import email from '../assets/email3.png';
import location from '../assets/location3.png'

export default function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white font-poppins">
      <Navbar />

      {/* Hero Banner - Softer version */}
      <section
        className="relative bg-cover bg-center py-28 md:py-40 text-white flex items-center justify-center overflow-hidden"
        style={{ backgroundImage: `url(${contactBg})` }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 font-joan">Contact Us</h1>
          <p className="text-xl md:text-2xl mb-10 font-light">
            We're here to help you 24/7. Reach out anytime — our team responds fast!
          </p>
          <Link
            to="/"
            className="inline-block px-8 py-4 bg-[#0B2A2C]/90 backdrop-blur-sm text-white rounded-full text-lg font-semibold hover:bg-[#0B2A2C] transition"
          >
            ← Back to Home
          </Link>
        </div>
      </section>

      {/* Main Contact + Newsletter Section */}
      <section className="py-20 bg-[#F3ECE2] px-4">
       <div className="max-w-7xl mx-auto grid lg:grid-cols-[1.6fr_1fr] gap-12 items-start">

          {/* Contact Form - Rounded blob style */}
          <div className=" rounded-3xl p-6  relative overflow-hidden">
            <h3 className="text-4xl font-bold text-[#0B2A2C] mb-8 text-center">Send us a Message</h3>
            <form className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
  <div className="relative">
    <input
      type="email"
      required
      className="w-full px-5 py-4 bg-white/70 rounded-3xl focus:outline-none focus:ring-4 focus:ring-[#0B2A2C]/30 peer"
      placeholder=" "
    />
    <label className="absolute left-5 top-4 text-gray-600 pointer-events-none transition-all
      peer-focus:-top-3 peer-focus:left-4 peer-focus:text-sm peer-focus:text-[#0B2A2C]
      peer-valid:-top-3 peer-valid:left-4 peer-valid:text-sm">
      Email Address *
    </label>
  </div>

  <div className="relative">
    <input
      type="tel"
      required
      className="w-full px-5 py-4 bg-white/70 rounded-3xl focus:outline-none focus:ring-4 focus:ring-[#0B2A2C]/30 peer"
      placeholder=" "
    />
    <label className="absolute left-5 top-4 text-gray-600 pointer-events-none transition-all
      peer-focus:-top-3 peer-focus:left-4 peer-focus:text-sm peer-focus:text-[#0B2A2C]
      peer-valid:-top-3 peer-valid:left-4 peer-valid:text-sm">
      Phone Number *
    </label>
  </div>
</div>

              <div className="relative">
                <input type="text" required className="w-full px-5 py-4 bg-white/70 rounded-3xl focus:outline-none focus:ring-4 focus:ring-[#0B2A2C]/30 peer" placeholder=" " />
                <label className="absolute left-5 top-4 text-gray-600 pointer-events-none transition-all peer-focus:-top-3 peer-focus:left-4 peer-focus:text-sm peer-focus:text-[#0B2A2C] peer-valid:-top-3 peer-valid:left-4 peer-valid:text-sm">Your Name *</label>
              </div>
              
              
              <div className="relative">
                <textarea rows={5} required className="w-full px-5 py-4 bg-white/70 rounded-3xl focus:outline-none focus:ring-4 focus:ring-[#0B2A2C]/30 peer resize-none" placeholder=" "></textarea>
                <label className="absolute left-5 top-4 text-gray-600 pointer-events-none transition-all peer-focus:-top-3 peer-focus:left-4 peer-focus:text-sm peer-focus:text-[#0B2A2C] peer-valid:-top-3 peer-valid:left-4 peer-valid:text-sm">Your Message *</label>
              </div>
              <button type="submit" className=" bg-[#0B2A2C] text-white px-6 py-4 rounded-full font-semibold hover:bg-[#0B2A2C]/90 transition shadow-lg">
                Send Message
              </button>
            </form>
          </div>

          {/* Newsletter Card */}
          <div className="bg-[#B2DFDB] rounded-2xl p-8 shadow-xl max-w-sm min-h-[400px] mt-12 lg:mt-24 flex flex-col justify-between">
  <h3 className="text-xl font-bold text-[#0B2A2C] mb-4">
    Our Newsletters
  </h3>

  <p className="text-sm text-gray-700 mb-6 leading-relaxed">
    Stay updated with health tips, wellness insights, and exclusive offers from AyuSanjivni.
    Get expert Ayurvedic insights, daily wellness inspiration, and exclusive member benefits.
  </p>

  <form className="flex flex-col gap-4">
    <input
      type="email"
      placeholder="Your Email"
      className="px-4 py-3 rounded-full bg-white/80 text-sm focus:outline-none focus:ring-2 focus:ring-[#0B2A2C]/30"
      required
    />

    <button
      type="submit"
      className="bg-[#0B2A2C] text-white py-3 rounded-full text-sm font-semibold hover:bg-black transition shadow-md"
    >
      Subscribe Now
    </button>
  </form>
</div>


        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-16 px-4 bg-[#F3ECE2]"> {/* Increased padding for more height */}
  <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">

    {/* Phone Card */}
    <div className="flex flex-col bg-[#0B2A2C] rounded-xl p-8 space-y-4"> {/* Increased padding */}
      <div className="flex items-center space-x-4">
        <div className="flex-shrink-0  p-4 rounded-lg">
          <img src={phone} alt="Phone" className="w-8 h-8" />
        </div>
        <h5 className="text-white font-semibold text-lg">(+91) 91000 00004</h5>
      </div>
      <p className="text-white text-sm leading-relaxed">
        Call us anytime for support or inquiries. Our team is happy to assist you with your needs.
      </p>
    </div>

    {/* Email Card */}
    <div className="flex flex-col bg-[#0B2A2C] rounded-xl p-8 space-y-4">
      <div className="flex items-center space-x-4">
        <div className="flex-shrink-0  p-4 rounded-lg">
          <img src={email} alt="Mail" className="w-8 h-8" />
        </div>
        <h5 className="text-white font-semibold text-lg">info@ayusanjivni.com</h5>
      </div>
      <p className="text-white text-sm leading-relaxed">
        Reach out via email for any questions or feedback. We respond promptly to all messages.
      </p>
    </div>

    {/* Location Card */}
    <div className="flex flex-col bg-[#0B2A2C] rounded-xl p-8 space-y-4 shadow-md">
      <div className="flex items-center space-x-4">
        <div className="flex-shrink-0  p-4 rounded-lg">
          <img src={location} alt="Location" className="w-8 h-8" />
        </div>
        <h5 className="text-white font-semibold text-lg">Ayusanjivni, Vijayawada</h5>
      </div>
      <p className="text-white text-sm leading-relaxed">
        Visit our office in Vijayawada for consultations and personalized support. We are here to help.
      </p>
    </div>

  </div>
</section>



      {/* Google Maps - Full width rounded */}
      <section className="py-20 px-4 bg-[#F3ECE2]">
        <div className="max-w-7xl mx-auto">
          <div className="bg-white rounded-3xl overflow-hidden shadow-2xl h-96 md:h-[600px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.853531292425!2d78.432098!3d17.419498!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb90c2e66c0001%3A0x3b5e0c3b0f0e0c3b!2sHyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1734000000000"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Clinic Location"
            ></iframe>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}